import type {ReactNode} from "react";
import {useState, useEffect} from "react";
import ReactDOM from "react-dom";

const Portal = ({children, renderInPlace}: {children: ReactNode; renderInPlace?: ReactNode}) => {
  const [node, setNode] = useState<HTMLElement | null>(null);
  const hasChildren = !!children;
  useEffect(() => {
    const targetNode = document.fullscreenElement ?? document.body;
    if (hasChildren) {
      const n = document.createElement("div");
      targetNode.appendChild(n);
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setNode(n);
      return () => {
        targetNode.removeChild(n);
      };
    } else {
      setNode(null);
    }
  }, [hasChildren]);
  return renderInPlace !== undefined ? (
    <>
      {renderInPlace}
      {node && ReactDOM.createPortal(children, node)}
    </>
  ) : (
    node && ReactDOM.createPortal(children, node)
  );
};

export default Portal;
